import React, { useEffect } from "react";
import { FormButtons, TailwindModal } from "../components";
import { observer } from "mobx-react-lite";
import { useStore } from "../helpers";
import { FormProvider, useForm } from "react-hook-form";
import { FTPCheckBox, FTPInput } from "../components-new";
import { toast } from "react-toastify";
import { safe_get } from "../report-visuals";

const AddNotaMaxSelect = ({ currentQuestion, handleSave }) => {
  const { projectStore } = useStore();
  const methods = useForm({});
  const onSubmit = (data) => {
    try {
      const ingest_payload = {
        more: {
          ...data,
        },
      };
      const final_payload = { ...currentQuestion, ...ingest_payload };
      handleSave(JSON.stringify(final_payload));
      projectStore.set_nota_max_select(false);
      toast.success("Added successfully");
    } catch (error) {
      toast.error("Something went wrong");
      console.log(error);
    }
  };
  const reset = () => {
    onSubmit({});
    methods.setValue("maxselect", "");
    methods.setValue("nota", false);
  };
  useEffect(() => {
    const hasConfig = safe_get(currentQuestion, "more", false);
    if (hasConfig) {
      console.log(hasConfig, "config");
      if (hasConfig?.maxselect) {
        methods.setValue("maxselect", hasConfig?.maxselect);
      }
      if (hasConfig?.nota) {
        methods.setValue("nota", hasConfig?.nota);
      }
    }
  }, [currentQuestion]);
  return (
    <TailwindModal isOpen={projectStore.notaMaxSelectModal}>
      <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle max-w-lg w-full">
        <FormProvider {...methods}>
          <form
            onSubmit={methods.handleSubmit(onSubmit)}
            className="bg-white px-4 py-2 rounded-sm flex flex-col gap-y-4"
          >
            <FTPInput
              label={"Max select option length"}
              name={"maxselect"}
              type="number"
            />
            <FTPCheckBox label={"Is Nota"} name={"nota"} />
            <button
              className="bg-red-400 p-2 text-white rounded-xl"
              type="button"
              onClick={() => reset()}
            >
              Remove
            </button>
            <FormButtons
              onSave={() => {}}
              onCancel={() => {
                projectStore.set_nota_max_select(false);
              }}
              type={"submit"}
            />
          </form>
        </FormProvider>
      </div>
    </TailwindModal>
  );
};

export default observer(AddNotaMaxSelect);
